import {gettext} from 'topmeteo/utils/i18n';

import BaseToggle from './BaseToggle';

const Title = gettext('Settings');

const ConfigToggle = props => (
    <BaseToggle
        {...props}
        className="config-toggle"
        panelType="config-header"
        title={Title}
        icon="cog"
    />
);

export default ConfigToggle;
